module.exports = __webpack_public_path__ + "static/mukaiImg2-d796d98f5e93f51f3cbad69c3d03d362.jpg";